import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MapJobLocation } from '../Models/Map-jobs.model';
import { SmartSearchRequest } from '../Models/Map-jobs.model';

export interface MapJobsResponse {
  MapLocations?: MapJobLocation[];
  TotalJobsCount?: number;
  ReturnedJobs?: number;
  PageSize?: number;
}
// 2. Add a proper REQUEST interface
export interface MapJobsRequest {
  PartnerId: number;
  SiteId: number;
  PageNumber: number;
  PageSize: number;
  Keyword: string[];
  Location: string[];
  FacetFilterFields: any | null;
  CallType: string;
  BringAllJobs: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class JobMapService {

  private apiUrl = '/TgNewUI/Search/Ajax/MapReleventedJobs';
  private matchedJobsUrl = '/TgNewUI/Search/Ajax/MatchedJobs';

  constructor(private http: HttpClient) { }

  getMapJobs(request: MapJobLocation): Observable<MapJobsResponse> {
    const url = `${this.apiUrl}`;
    return this.http.post<MapJobsResponse>(url, request);
  }

  getMatchedJobs(request: SmartSearchRequest): Observable<any> {
    const url = `${this.matchedJobsUrl}`;
    return this.http.post<any>(url, request);
  }
}